{
  "version": "1.2.6",
  "objects": {
    "7430093515438148456": {
      "type": "frame",
      "id": "7430093515438148456",
      "z": 7263,
      "textContent": "",
      "left": -1058.9060742361248,
      "top": 2147.2087284670138,
      "width": 400,
      "height": 500,
      "scaleX": 0.7694665816350448,
      "scaleY": 0.09858628735634853,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 10,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7430093515436275345": {
      "type": "frame",
      "id": "7430093515436275345",
      "z": 7024,
      "textContent": "Frame 96",
      "left": -1009.6129305579506,
      "top": 2159.855300306101,
      "width": 400,
      "height": 500,
      "scaleX": 0.5630779820215777,
      "scaleY": 0.05,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7430093515438148456",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 0,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7430093515438423436": {
      "type": "shape",
      "id": "7430093515438423436",
      "z": 7025,
      "shapeName": "text",
      "textContent": "<p>Notification banner description</p>",
      "left": -1009.6129305579506,
      "top": 2159.855300306101,
      "width": 198.33333333333334,
      "height": 29.166666666666668,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.8571428571428571,
      "scaleY": 0.8571428571428571,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 12,
      "angle": 0,
      "container": "7430093515436275345",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430093515439782666": {
      "type": "wireframe",
      "id": "7430093515439782666",
      "z": 7026,
      "top": 2157.7087284670138,
      "left": -1048.9060742361248,
      "width": 52,
      "height": 52,
      "scaleX": 0.5633296861187359,
      "scaleY": 0.5633296861187359,
      "container": "7430093515438148456",
      "layoutPosition": "Zzzzzx",
      "wireframeName": "avatar",
      "fill": "#4A388E",
      "textColor": "#333333",
      "style": "square",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "value": "",
        "iconLeft": { "prefix": "fas", "iconName": "bell" },
        "iconRight": null
      },
      "showBackground": true,
      "showOutline": true
    },
    "7430093515443313715": {
      "type": "shape",
      "id": "7430093515443313715",
      "z": 7027,
      "shapeName": "icon",
      "textContent": "",
      "left": -774.3817377493194,
      "top": 2164.145463372331,
      "width": 100,
      "height": 160,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.10262296167212569,
      "scaleY": 0.10262296167212569,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": "#BDBDBD",
      "angle": 0,
      "container": "7430093515438148456",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "iconName": "fas/xmark",
      "locked": false
    }
  }
}
